import { Row, Col, Alert, Button } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { TextField, Label } from 'components';
import React, { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { initiateNewPasswordFlow } from 'store/user/actions';
import { types } from 'store/user/types';
import { types as formTypes } from 'store/form/types';
import keycloak from 'Keycloak.js';

const NewPasswordPage = () => {
  const dispatch = useDispatch();
  const params =  useSelector(state => state.user);
  const initiated =  useSelector(state => state.form.initiated);
  const hasError =  useSelector(state => state.form.hasError);
  const hasInfo =  useSelector(state => state.form.hasInfo);
  const loading =  useSelector(state => state.form.loading);
  const message =  useSelector(state => state.form.message);
  const inputRef = useRef(null);
  const errorMessage = useSelector(state => state.form.errorMessage);
  const submitClicked = (e) => {
    dispatch(initiateNewPasswordFlow(params));
  };
  useEffect(() => {
    dispatch({ type: types.RESET_USER });
    dispatch({ type: formTypes.RESET_FORM });
    keycloak.tracker.invalidateUserForAuthPages(false, (data) => {
      keycloak.tracker.installMonitorIdmSession(data, true);
      keycloak.redirectToHome();
    }, (data) => {
      keycloak.tracker.installMonitorIdmSession(data, true);
      dispatch({ type: formTypes.SET_FORM_INITIATED });
    }); 
  }, []);
  useEffect(() => {
    initiated && inputRef.current.focus();
  }, [initiated]);
  return (
    initiated &&
    <div className="newpass-page">
      <Row className="page-title-row newpass-title-row">
        <Col span={24} className="page-title-col newpass-title-col">
          <Label
            label="Αλλαγή Κωδικού"
            labelClassName="page-title-label newpass-title-label"
          />
        </Col>
      </Row>
      <Row className="error-wrapper-row">
        <Col span={24} className="error-wrapper-col">
          {hasError && <Alert
            message="Σφάλμα"
            description={message}
            className="error-component"
            type="error"
            icon={<ExclamationCircleFilled />}
            closable
            showIcon
          />}
          {hasInfo && <Alert
            //message="Σφάλμα"
            description={message}
            className="info-component"
            type="info"
            icon={<ExclamationCircleFilled />}
            closable
            showIcon

          />}
        </Col>
      </Row>
      <Row className="userpass-wrapper-row">
        <Col span={24} className="userpass-wrapper-col">
        <TextField
            className="password-component"
            labelClassName="userpass-label password-label"
            containerClassName="password-container"
            fieldName="password"
            fieldType="password"
            label="Νέος Κωδικός"
            size="large"
            placeholder="Εισάγετε κωδικό"
            disabled={loading}
            customRef={inputRef}
            onPressEnter={submitClicked}
          />
          <TextField
            className="password-component"
            labelClassName="userpass-label password-label"
            containerClassName="password-container"
            fieldName="confirmPassword"
            fieldType="password"
            label="Επιβεβαίωση Κωδικού"
            size="large"
            placeholder="Εισάγετε κωδικό"
            disabled={loading}
            onPressEnter={submitClicked}
          />
        </Col>
      </Row>
      <Row className="buttons-wrapper-row">
        <Col span={24} className="buttons-wrapper-col">
          <Button
            type="primary"
            className="submit-component"
            disabled={loading}
            onClick={submitClicked}
            >Submit</Button>
        </Col>
      </Row>
    </div>
  );
};

export default NewPasswordPage;
